export default __webpack_public_path__ + "static/media/102_desktop.2f9fe902.jpg";